import React ,{useEffect, useState} from 'react'
import {Button, Col, Input, Row, Card, Form, message,Typography,Layout, Tooltip, Tabs, Select} from "antd";
import cookie from "react-cookies"
import {LoginOutlined,LockTwoTone,UserOutlined,LockOutlined,InfoCircleOutlined} from '@ant-design/icons'
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"
import img2 from "../IMG/8.jpg"

// require("../css/normalize.css")
// require("../css/stylogin.css")
require("../css/mainPageBackgroundImage.css")

export function UserLogin(){


    useEffect(
        ()=>{
            findAll()
        },[]
    );


    const { TabPane } = Tabs;
    const { Option } = Select;
    const { Header, Footer, Sider, Content } = Layout;

    const mainPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/experi"
    }
    const teacherPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/user/resources"
    }

    const username = "username"
    const classId = "classID"
    const role = "role"
    const userId = "userId"
    const roleUserTest = "student"
    const roleTeacherTest = "teacher"
    const { Title } = Typography;

    const [classInfo,setClassInfo] = useState([]);


    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/findAll",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify("{}"),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setClassInfo(data)
            })
            .catch(error => message.error("error"+error));
    }

    const register=(user)=>{
        fetch(
            "http://"+getHostAddress()+"/user/register",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(user),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                if (data.message === "注册成功"){
                    message.success(data.message)
                }else {
                    message.error(data.message)
                }
            })
            .catch(error => message.error("error"+error));
    }

    let user
    const [userData,setUserData] = useState();
    const login=(data)=>{
        fetch(
            "http://"+getHostAddress()+"/user/login",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(data),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                if (data === null || data === undefined || data === "" || data === "{}" || data.id === null){
                    message.error("用户名或密码错误")
                }else if(data.id !== null && (data.name === name || data.studentNumber == name) && data.role === 'student' || data.role ==='teacher'){
                    message.success("登录成功");
                    //let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000);//一天
                    //cookie.save(username,data.name,{ expires: inFifteenMinutes })
                    //cookie.save(role,data.role,{ expires: inFifteenMinutes })
                    // console.log("data-----------")
                    // console.log(data)
                    console.log(data)

                    cookie.remove(userId)
                    cookie.remove(username)
                    cookie.remove(role)
                    cookie.remove(classId)
                    cookie.remove(roleUserTest)
                    cookie.remove(roleTeacherTest)

                    cookie.save(userId,data.id)
                    cookie.save(username,data.name)
                    cookie.save(role,data.role)
                    cookie.save(classId,data.classId)
                    cookie.save(roleUserTest,roleUserTest)
                    cookie.save(roleTeacherTest,roleTeacherTest)
                    console.log("username:"+cookie.load(username))
                    console.log("role:"+cookie.load(role))
                    console.log("userId:"+cookie.load(classId))
                    if (cookie.load(role)==="student"){
                        mainPage()
                    }
                    if(cookie.load(role)==="teacher"){
                        teacherPage()
                    }
                }else {
                    console.log(data)
                    message.info("不是用户角色")
                }
            })
            .catch(error => message.error("error"+error));
    }

    //classId
    let class_Id
    const classIdOnChange=(value)=> {
        class_Id = value
    }

    let role_name
    const role_nameOnChange=(value)=> {
        role_name = value
    }

    const loginConnection = ()=>{

        if (name === "" || name === null || name === undefined){
            message.error("id不得为空")
        }

        if (password === "" || password === null || password === undefined){
            message.error("密码不得为空")
        }

        let jsonData = {
            name:name,
            password:password
        }
        login(jsonData)
    }


    const registerClick = ()=>{

        if (name ==="" || password===""  || class_Id==="" || registerCode==="" || role_name===""){
            message.error("部分数据为空")
            return
        }

        if (name ===null || password===null  || class_Id===null || registerCode===null || role_name===null){
            message.error("部分数据为空")
            return
        }

        if (name ===undefined || password===undefined  || class_Id===undefined || registerCode===undefined || role_name === undefined){
            message.error("部分数据为空")
            return
        }

        const data ={
            name:name,
            password:password,
            role:role_name,
            classId:class_Id,
            registerCode:registerCode
        }
        register(data)
    }


    let name
    const idOnChange = e =>{
        console.log(e.target.value)
        name = e.target.value
    }

    let password
    const pwdOnchange = e =>{
        console.log(e.target.value)
        password = e.target.value
    }

    let registerCode
    let registerInput = e =>{
        registerCode = e.target.value
    }

    let sectionStyle = {
        width: "100%",
        height: "100%",
        // makesure here is String确保这里是一个字符串，以下是es6写法
        backgroundImage: `url(${img2})`,
        backgroundSize: "cover",
    };



    const layout =(
        <div style={sectionStyle}>
            <div style={{height:"121px"}}></div>
            <div>
            <div ></div>
            <Row gutter={[24,24]} >
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={14}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={7}>

                    <Tabs defaultActiveKey="1" >
                        <TabPane tab="登录" key="1">
                            <Card style={{height:340,width:439}}>
                                <Row gutter={[10,10]}>
                                    <Col span={9}></Col>
                                    <Title level={3}>用户登录</Title>
                                </Row>
                                <Row gutter={[10,10]}>
                                    <Input size="large"
                                           placeholder="用户名"
                                           prefix={<UserOutlined style={{color:"#1890FF"}} />}
                                           onChange={idOnChange}
                                           suffix={
                                               <Tooltip title="输入您的账号">
                                                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                               </Tooltip>
                                           }
                                    >

                                    </Input>
                                </Row>
                                <br/>
                                <Row gutter={[1,1]}>
                                    <Input size="large"
                                           placeholder="密码"
                                           prefix={<LockTwoTone twoToneColor="#1890FF" />}
                                           type={"password"}
                                           onChange={pwdOnchange}
                                           suffix={
                                               <Tooltip title="输入您的密码,注意大小写">
                                                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                               </Tooltip>
                                           }
                                    >

                                    </Input>
                                </Row>
                                <br/>
                                <Row>
                                    <Col span={10}>

                                    </Col>
                                    <Col>
                                        <Button icon={<LoginOutlined />} type="primary" onClick={loginConnection}>登录</Button><br/>
                                    </Col>
                                </Row>
                            </Card>
                        </TabPane>
                        <TabPane tab="注册" key="2">
                            <Card style={{height:340,width:439}}>
                                <Row gutter={[10,10]}>
                                    <Col span={9}></Col>
                                    <Title level={3}>用户注册</Title>
                                </Row>
                                <Row gutter={[10,10]}>
                                    <Input size="large"
                                           placeholder="用户名:用于登录"
                                           prefix={<UserOutlined style={{color:"#1890FF"}} />}
                                           onChange={idOnChange}
                                           suffix={
                                               <Tooltip title="输入您的账号">
                                                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                               </Tooltip>
                                           }
                                    >

                                    </Input>
                                </Row>
                                <br/>
                                <Row gutter={[1,1]}>
                                    <Input size="large"
                                           placeholder="密码"
                                           prefix={<LockTwoTone twoToneColor="#1890FF" />}
                                           type={"password"}
                                           onChange={pwdOnchange}
                                           suffix={
                                               <Tooltip title="输入您的密码,注意大小写">
                                                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                               </Tooltip>
                                           }
                                    >
                                    </Input>
                                </Row>
                                <br/>
                                <Row gutter={[1,1]}>
                                    <Input size="large"
                                           placeholder="注册码"
                                           prefix={<LockTwoTone twoToneColor="#1890FF" />}
                                           onChange={registerInput}
                                           suffix={
                                               <Tooltip title="注册码">
                                                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                               </Tooltip>
                                           }
                                    >
                                    </Input>
                                </Row>
                                <br/>
                                <Row gutter={[1,1]}>
                                    <Select
                                        defaultValue={"选择班级"}
                                        style={{ width: 120 }}
                                        onChange={classIdOnChange}
                                    >
                                        {
                                            classInfo.map(
                                                ci=><Option key={ci.id}>{ci.className}</Option>
                                            )
                                        }
                                    </Select>
                                    <Select
                                        defaultValue={"选择角色"}
                                        style={{ width: 120 }}
                                        onChange={role_nameOnChange}
                                    >
                                        <Option key={"teacher"}>老师</Option>
                                        <Option key={"student"}>学生</Option>
                                    </Select>
                                </Row>
                                <br/>
                                <Row>
                                    <Col span={10}>

                                    </Col>
                                    <Col>
                                        <Button icon={<LoginOutlined />} type="primary" onClick={registerClick}>注册</Button><br/>
                                    </Col>
                                </Row>
                            </Card>
                        </TabPane>
                    </Tabs>
                </Col>
                <Col>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
                <Col span={23}>
                    {/*<Card>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Input ></Input>*/}
                    {/*    <Button type="primary">login</Button>*/}
                    {/*</Card>*/}
                </Col>
            </Row>
        </div>
        </div>
    )

    // let sty={
    //     width: '100%',
    //     marginBottom: '10px',
    //     background: 'rgba(0,0,0,0.3)',
    //     border: 'none',
    //     outline: 'none',
    //     padding: '10px',
    //     fontSize: '13px',
    //     color: '#fff',
    //     textShadow: '1px 1px 1px rgba(0,0,0,0.3)',
    //     border: '1px solid rgba(0,0,0,0.3)',
    //     borderRadius: '4px',
    //     boxShadow: 'inset 0 -5px 45px rgba(100,100,100,0.2), 0 1px 1px rgba(255,255,255,0.2)',
    //     webkitTransition: 'box-shadow .5s ease',
    //     MozTransition: 'box-shadow .5s ease',
    //     OTransition: 'box-shadow .5s ease',
    //     msTransition: 'box-shadow .5s ease',
    //     transition: 'box-shadow .5s ease',
    //     boxShadow:'inset 0 -5px 45px rgba(100,100,100,0.4), 0 1px 1px rgba(255,255,255,0.2)',
    //     fontFamily: 'Open Sans'
    // }

    let borSty = {
        //border:"1px solid #ccc"
    }

    return(
        <>
            <Row>
                <Col style={borSty} span={8}>&nbsp;</Col>
                <Col style={borSty} span={8} offset={8}>&nbsp;</Col>
            </Row>
            <Row>
                <Col style={borSty} span={6} offset={6}>
                    &nbsp;
                </Col>
                <Col style={borSty} span={6} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>

            {/*100%*/}
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            {/*100%*/}

            <Row>
                <Col style={borSty} span={7} offset={13}>
                    <div className="login">
                        <Card style={{
                            // height:200,
                             width:450,
                            //margin:"230px 0 0 810px"
                        }}>
                            <Row>
                                <Col style={borSty} span={12} offset={8}>
                                    <Title level={4}>用户登录</Title>
                                </Col>
                            </Row>
                            <Form>
                                <Form.Item>
                                <Input //style={sty}
                                    size="large"
                                    placeholder="用户名"
                                    onChange={idOnChange}
                                >
                                </Input>
                                </Form.Item>
                                <Form.Item>
                                <Input //style={sty}
                                    size="large"
                                    placeholder="密码"
                                    type={"password"}
                                    onChange={pwdOnchange}
                                >
                                </Input>
                                </Form.Item>
                                <Form.Item>
                                <Button
                                    type="primary" block
                                    onClick={loginConnection}
                                >登录</Button><br/>
                                </Form.Item>
                                {/*<input type="text" name="u" placeholder="用户名" required="required"/>*/}
                                {/*<input type="password" name="p" placeholder="密码" required="required"/>*/}
                                {/*<button type="submit" className="btn btn-primary btn-block btn-large">登录</button>*/}
                            </Form>
                        </Card>
                    </div>
                </Col>
            </Row>
        </>
    )
}
